import type { Button } from "@/components/ui/button";
import type { AlertDialogCancel } from "@/components/ui/alert-dialog";
import type * as React from "react";

export type ConfirmOptions = {
  title?: React.ReactNode;
  description?: React.ReactNode;
  cancelText?: React.ReactNode;
  actionText?: React.ReactNode;
  CancelProps?: React.ComponentProps<typeof AlertDialogCancel>;
  ActionProps?: React.ComponentProps<typeof Button>;
};

type ConfirmRequest = ConfirmOptions & {
  id: number;
  resolve: (value: boolean) => void;
};

type Listener = (request: ConfirmRequest | null) => void;

let listener: Listener | null = null;
let counter = 0;

export function registerConfirmListener(next: Listener | null) {
  listener = next;
}

export async function confirm(options: ConfirmOptions): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    if (!listener) {
      console.warn("<Confirmer /> is not mounted; confirm() resolves false.");
      resolve(false);
      return;
    }
    counter += 1;
    listener({ ...options, id: counter, resolve });
  });
}

export type { ConfirmRequest, Listener };
